"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBSuggestionPositive = function SvgBSuggestionPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M59.683 143.567a2.097 2.097 0 01-.965-3.97l26.305-13.17a2.097 2.097 0 111.88 3.746l-26.283 13.17a2.05 2.05 0 01-.937.224zM57.104 130.397a2.097 2.097 0 01-.77-4.047l33.785-13.282a2.098 2.098 0 011.53 3.908l-33.776 13.281a2.14 2.14 0 01-.77.14z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M83.268 143.567H59.683a2.097 2.097 0 110-4.195h23.585a2.097 2.097 0 010 4.195zM85.98 130.397H57.105a2.097 2.097 0 110-4.194H85.98a2.097 2.097 0 010 4.194zM90.874 117.13H61.298a2.097 2.097 0 110-4.195h29.576a2.097 2.097 0 110 4.194z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M87.064 117.13H58.816c-6.892-.008-12.477-5.593-12.484-12.485v-6.99a17.21 17.21 0 00-6.69-13.674 49.066 49.066 0 01-19.573-39.404C20.115 20.363 39.733.745 63.947.7h.965a2.097 2.097 0 010 4.194h-.965c-21.912.023-39.673 17.772-39.712 39.684A44.906 44.906 0 0042.172 80.64a21.418 21.418 0 018.389 17.014v6.99a8.297 8.297 0 008.29 8.291H87.1a2.097 2.097 0 110 4.194h-.035z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M94.663 107.182a2.097 2.097 0 01-2.098-2.097v-7.69a21.418 21.418 0 018.256-16.937 44.948 44.948 0 0017.734-35.88c-.038-21.913-17.8-39.662-39.712-39.685h-.74a2.097 2.097 0 110-4.194h.74c24.227.027 43.864 19.652 43.907 43.878a49.094 49.094 0 01-19.378 39.237 17.19 17.19 0 00-6.612 13.61v7.689a2.097 2.097 0 01-2.097 2.07zM71.602 70.777a2.097 2.097 0 01-1.482-.615L52.245 52.287A12.177 12.177 0 0166.01 32.645a2.098 2.098 0 11-1.775 3.802 7.983 7.983 0 00-9.01 12.876l17.873 17.875a2.097 2.097 0 01-1.481 3.579h-.014z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M78.096 64.248a2.097 2.097 0 01-1.49-3.58l11.346-11.345A7.983 7.983 0 0076.67 38.034l-3.272 3.25a2.098 2.098 0 01-2.97-2.963l3.25-3.25a12.184 12.184 0 1117.245 17.216L79.577 63.612c-.389.4-.922.63-1.481.636z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M140.938 51.03h-6.627a2.097 2.097 0 010-4.195h6.627a2.097 2.097 0 110 4.194zM22.271 93.362a2.097 2.097 0 01-1.398-3.649l4.893-4.466a2.097 2.097 0 012.796 3.103l-4.893 4.467c-.383.348-.88.542-1.398.545zM115.675 8.661a2.097 2.097 0 01-1.398-3.649L119.17.545a2.097 2.097 0 012.797 3.104l-4.894 4.467c-.382.348-.88.542-1.398.545zM120.576 93.362a2.097 2.097 0 01-1.399-.545l-4.893-4.467a2.097 2.097 0 012.803-3.068l4.894 4.466a2.097 2.097 0 01-1.398 3.65l-.007-.036zM27.171 8.661a2.097 2.097 0 01-1.398-.545L20.88 3.649A2.097 2.097 0 0123.676.545l4.893 4.467a2.097 2.097 0 01-1.398 3.649zM9.087 51.03H2.44a2.097 2.097 0 010-4.195h6.647a2.097 2.097 0 110 4.194z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M8.73 51.03H2.098a2.097 2.097 0 010-4.195h6.634a2.097 2.097 0 110 4.194z",
    fill: "#1B7"
  })));
};

var _default = SvgBSuggestionPositive;
exports["default"] = _default;